import { useEffect, useRef, useState } from 'react';
import useTranslation from 'next-translate/useTranslation';
import { ChevronRight, Close, Monetization } from '@eqi-investimentos/icons/web';
import { Box, Flex, Text } from '@eqi-investimentos/react';
import { MODAL_INVEST_ID } from '@/viewModels/InvestViewModel/utils';
import { IfRender } from '@/utils/jsx';
import { Button } from '../Button';
export const InvestFloatingButton = () => {
  const {
    t
  } = useTranslation('common');
  const timerRef = useRef<number | null>(null);
  const startTimeRef = useRef<number>(0);
  const [show, setShow] = useState(false);
  const [isSmallMode, setIsSmallMode] = useState(false);
  const openInvestDrawer = () => window.dispatchEvent(new Event(`open-chakra-modal-${MODAL_INVEST_ID}`));
  const updateButtonState = () => {
    const elapsed = Date.now() - startTimeRef.current;
    if (elapsed >= 36000) {
      setIsSmallMode(true);
      return;
    }
    if (elapsed >= 30000) {
      setShow(true);
    }
    timerRef.current = requestAnimationFrame(updateButtonState);
  };
  useEffect(() => {
    startTimeRef.current = Date.now();
    timerRef.current = requestAnimationFrame(updateButtonState);
    return () => {
      if (timerRef.current) {
        cancelAnimationFrame(timerRef.current);
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return <Box pos="absolute" right="0" bottom="20%" pr="8" zIndex="10" data-sentry-element="Box" data-sentry-component="InvestFloatingButton" data-sentry-source-file="index.tsx">
      <Flex pos="relative" display={show ? 'flex' : 'none'} justifyContent="flex-end" w={isSmallMode ? '7.5rem' : '22.8125rem'} h="5.3125rem" py="0.9375rem" pr="1.5625rem" transition="opacity 500ms ease-in" data-sentry-element="Flex" data-sentry-source-file="index.tsx">
        <IfRender condition={isSmallMode} data-sentry-element="IfRender" data-sentry-source-file="index.tsx">
          <Button data-testid="close-button" onClick={() => setShow(false)} ariaLabel="Fechar" pos="absolute" top="0" right="0" p="0" minW="1.875rem" maxW="1.875rem" h="1.875rem" bgColor="neutral.400" borderRadius="full" transition="all 500ms ease-in" data-sentry-element="Button" data-sentry-source-file="index.tsx">
            <Close w={16} h={16} color="neutral.600" data-sentry-element="Close" data-sentry-source-file="index.tsx" />
          </Button>
        </IfRender>
        <Button variant="naked" data-testid="invest-floating-button" onClick={openInvestDrawer} display="inline-flex" flexDir="column" justifyContent="flex-start" alignItems="flex-start" px="5" py="0.9375rem" w="21rem" h="3.75rem" bgColor="background.inverse" borderRadius="lg" transition="all 500ms ease-in" {...isSmallMode && {
        justifyContent: 'center',
        alignItems: 'center',
        w: '4.375rem',
        h: '4.375rem',
        borderRadius: 'full'
      }} data-sentry-element="Button" data-sentry-source-file="index.tsx">
          <Flex display="inline-flex" alignItems="center" justifyContent="space-between" alignSelf="stretch" data-sentry-element="Flex" data-sentry-source-file="index.tsx">
            <Flex display="inline-flex" alignItems="center" gap="2.5" sx={{
            '.chakra-icon,': {
              w: '1.875rem !important',
              h: '1.875rem !important'
            }
          }} data-sentry-element="Flex" data-sentry-source-file="index.tsx">
              <Monetization w="1.875rem" h="1.875rem" fill="action.active.brandLight" data-sentry-element="Monetization" data-sentry-source-file="index.tsx" />
              <Text display={isSmallMode ? 'none' : 'block'} lineHeight="shorter" color="action.active.brandLight" data-sentry-element="Text" data-sentry-source-file="index.tsx">
                {`${t('attributes.investPrepA')} ${t('attributes.now')}!`}
              </Text>
            </Flex>
            <IfRender condition={!isSmallMode} data-sentry-element="IfRender" data-sentry-source-file="index.tsx">
              <ChevronRight width={16} height={16} fill="content.alwaysLight" data-sentry-element="ChevronRight" data-sentry-source-file="index.tsx" />
            </IfRender>
          </Flex>
        </Button>
      </Flex>
    </Box>;
};